function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import PropTypes from "prop-types";
import { default as MuiTextField } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import VerifiedIcon from "@mui/icons-material/Verified";
import { convertHex, brandPrimary } from "../../../constants";
function TextField(props) {
  return /*#__PURE__*/React.createElement(MuiTextField, _extends({
    variant: "outlined",
    disabled: props.verified,
    InputLabelProps: {
      style: {
        fontSize: "0.9375rem"
      }
    },
    InputProps: _objectSpread({
      style: {
        fontSize: "0.9375rem"
      },
      endAdornment: props.verified && /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(VerifiedIcon, {
        style: {
          color: brandPrimary
        }
      }))
    }, props.InputProps)
  }, props));
}
export default TextField;
TextField.defaultProps = {
  verified: false
};
TextField.propTypes = {
  verified: PropTypes.bool
};
export var plainColorStyle = function plainColorStyle(_ref) {
  var color = _ref.color,
    theme = _ref.theme;
  return {
    "& label.Mui-focused": {
      color: theme.palette[color || "primary"].text
    },
    "& .MuiInputBase-input": {
      color: theme.palette[color || "primary"].text,
      "&.Mui-disabled": {
        "-webkit-text-fill-color": theme.palette[color || "primary"].text
      }
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: theme.palette[color || "primary"].text
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette[color || "primary"].main
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "1px solid ".concat(theme.palette[color || "primary"].main)
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: theme.palette[color || "primary"].main
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette[color || "primary"].main
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: convertHex(theme.palette[color || "primary"].main, 23)
      },
      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: convertHex(theme.palette[color || "primary"].main, 23)
      },
      "&.Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette[color || "primary"].main
      }
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette[color || "primary"].main
    },
    "& .MuiInputBase-root.MuiInput-root.Mui-error:before": {
      borderBottomColor: theme.palette[color || "primary"].main
    },
    "& .MuiInputBase-root.MuiInput-root.Mui-error:after": {
      borderBottomColor: theme.palette[color || "primary"].main
    }
  };
};
export var numericFormatLargeStyle = function numericFormatLargeStyle(_ref2) {
  var color = _ref2.color,
    theme = _ref2.theme;
  return {
    "& .MuiInputBase-root": {
      fontSize: "2rem"
    }
  };
};
export var numericFormatSmallStyle = function numericFormatSmallStyle(_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return {
    "& .MuiInputBase-root": {
      fontSize: "1.5rem"
    },
    "& .MuiFilledInput-input": {
      paddingTop: "12px"
    }
  };
};
export var pageSizeStyle = function pageSizeStyle(_ref4) {
  var color = _ref4.color,
    theme = _ref4.theme;
  return {
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
      fontSize: "0.875rem"
    }
  };
};